var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-detail-inner site-detail-inner-backups"},[_c('backup-section',{attrs:{"show-full-list-link":false,"show-back-link":true,"show-pagination":true,"limit":20},on:{"close-detail":_vm.close}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }